<template>
  <component
    :is="page"
    @navigate="navigate"
    @accept="accept"
    @cancel="cancel"
    @retry="retry"
    :consentInfo="consentInfo"
    :errorType="errorType"
  />
</template>

<script>
import ConfirmConsent from "../pages/ConfirmConsent.vue";
import Error from "../pages/Error.vue";
import { isMobileOnly } from "mobile-device-detect";

export default {
  name: "Consent",
  props: {
    consentChallenge: {
      type: String,
    },
  },
  components: {
    ConfirmConsent,
    Error,
  },
  data() {
    return {
      page: "ConfirmConsent",
      consentInfo: {
        isLoading: true,
        scopes: {
          verification: false,
          signing: false,
          mynumber: false,
          card: false,
          jpki: false,
          pittari: false,
          vc: false,
          vp: false,
          vc_issuer: false,
          sp_messages: false,
          serial: false,
          cardinput: false,
        },
        clientName: "",
        termsURL: "",
        privacyURL: "",
        redirectURL: "",
      },
      errorType: "consentFailed",
      isPrerenderFinish: false,
      isPrerenderProcessing: false,
      isAcceptProcessing: false,
      isConsentSkip: false,
    };
  },
  mounted() {
    localStorage.removeItem("login_challenge");
    document.addEventListener("visibilitychange", this.checkSkip);
    this.prerender();
  },
  methods: {
    navigate(val) {
      this.errorType = val.errorType;
      this.page = val.page;
    },
    getScope(scopes) {
      scopes.forEach((key) => {
        switch (key) {
          case "verification":
            this.consentInfo.scopes.verification = true;
            break;
          case "signing":
            this.consentInfo.scopes.signing = true;
            break;
          case "mynumber":
            this.consentInfo.scopes.mynumber = true;
            break;
          case "reverification":
            this.consentInfo.scopes.card = true;
            break;
          case "jpki":
            this.consentInfo.scopes.jpki = true;
            break;
          case "pittari":
            this.consentInfo.scopes.pittari = true;
            break;
          case "vc":
            this.consentInfo.scopes.vc = true;
            break;
          case "vp":
            this.consentInfo.scopes.vp = true;
            break;
          case "vc_issuer":
            this.consentInfo.scopes.vc_issuer = true;
            break;
          case "sp_messages":
            this.consentInfo.scopes.sp_messages = true;
            break;
          case "serial":
            this.consentInfo.scopes.serial = true;
            break;
          case "cardinput":
            this.consentInfo.scopes.cardinput = true;
            break;
          default:
            break;
        }
      });
    },
    checkSkip() {
      if (
        document.visibilityState === "visible" &&
        this.consentInfo.redirectURL != ""
      ) {
        window.location.replace(this.consentInfo.redirectURL);
        return;
      }
    },
    retry() {
      if (this.isPrerenderFinish == false) {
        this.prerender();
        return;
      }
      this.accept();
    },
    async accept() {
      if (this.isAcceptProcessing == true) {
        return;
      }
      this.isPrerenderFinish = true;
      this.isAcceptProcessing = true;

      const postData = {
        consent_challenge: this.$route.query.consent_challenge,
      };

      try {
        const res = await fetch(
          "https://" +
            process.env.VUE_APP_API +
            ".x-id.io/authorization/consent/accept",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
            body: JSON.stringify(postData),
          }
        );
        if (!res.ok) {
          this.isAcceptProcessing = false;
          const errorText = await res.text();
          // When smartPOST service is not working on v5
          if (errorText == "0172008") {
            this.navigate({
              page: "Error",
              errorType: "smartPOSTNotSupported",
            });
            return;
          }
          this.navigate({
            page: "Error",
            errorType: "consentFailed",
          });
          return;
        }

        const resData = await res.json();
        const url = resData.redirect_url;
        if (url && url != "") {
          this.isAcceptProcessing = false;
          if (this.isConsentSkip == true) {
            this.consentInfo.redirectURL = url;
          }
          window.location.replace(url);
          return;
        }
      } catch (error) {
        this.isAcceptProcessing = false;
        this.navigate({
          page: "Error",
          errorType: "consentFailed",
        });
      }
    },
    async prerender() {
      if (this.isPrerenderProcessing == true) {
        return;
      }
      this.isPrerenderProcessing = true;

      try {
        const res = await fetch(
          "https://" +
            process.env.VUE_APP_API +
            ".x-id.io/authorization/consent/prerender?consent_challenge=" +
            this.$route.query.consent_challenge,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
          }
        );

        if (!res.ok) {
          this.isPrerenderProcessing = false;
          const errorText = await res.text();
          // When smartPOST service is not working on v6
          if (errorText == "sp_unavalible") {
            this.navigate({
              page: "Error",
              errorType: "smartPOSTNotSupported",
            });
            return;
          }
          this.navigate({
            page: "Error",
            errorType: "consentFailed",
          });
          return;
        }
        const resData = await res.json();
        if (resData.skip) {
          if (isMobileOnly) {
            this.isConsentSkip = true;
          }
          this.accept();
          return;
        } else {
          this.consentInfo.isLoading = false;
          this.getScope(resData.scope);
          this.consentInfo.clientName = resData.client_name;
          this.consentInfo.privacyURL = resData.policy_uri;
          this.consentInfo.termsURL = resData.tos_uri;
          return;
        }
      } catch (error) {
        this.isPrerenderProcessing = false;
        this.navigate({
          page: "Error",
          errorType: "consentFailed",
        });
      }
    },
    async cancel() {
      const postData = {
        consent_challenge: this.$route.query.consent_challenge,
      };

      try {
        const res = await fetch(
          "https://" +
            process.env.VUE_APP_API +
            ".x-id.io/authorization/consent/cancel",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            cache: "no-cache",
            body: JSON.stringify(postData),
          }
        );

        if (!res.ok) {
          return;
        }

        const resData = await res.json();
        const url = resData.redirect_url;
        if (url && url != "") {
          window.location.replace(url);
          return;
        }
      } catch (error) {
        return;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
#box
  .expandWrapper.scopes
    li.scope
      &:last-child
        margin-bottom: 0px !important
  h1
    +lh(14)
  .expandWrapper.loading
    +flex()
  .wrapper
    margin-top: 12px
    +flex(space-between, center, row)
</style>